import React from 'react';
import { theme } from 'antd';

const About: React.FC = () => {
  const { token } = theme.useToken();

  return (
    <div style={{ padding: '96px 24px 24px' }}>
      <h1 style={{ fontSize: token.fontSizeHeading2, color: token.colorText, marginBottom: 16 }}>
        About
      </h1>
      <p style={{ fontSize: token.fontSize, color: token.colorTextSecondary, lineHeight: 1.6 }}>
        Spec is a platform for discovering live music, connecting with bands, musicians, and venues in your area.
      </p>
      <p style={{ fontSize: token.fontSize, color: token.colorTextSecondary, lineHeight: 1.6, marginTop: 16 }}>
        Whether you're a music fan looking for your next show, a musician seeking gigs, or a venue wanting to promote events, Spec brings the local music community together.
      </p>
    </div>
  );
};

export default About;
